import React from 'react'

const strokeStyle = { vectorEffect: 'non-scaling-stroke' }

const BlogIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff"><path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z" /></svg>
)

export default BlogIcon
